const styleId = 'icf-easter-egg-message-style'

// The hint reuses the real newsticker classes (newsticker-toast, slide-up,
// text-bg-*, close ...) so it always matches the corporate design. Only the
// slide layout is replicated below, because in newsticker/style.scss those
// rules are bound to the swiper-slide element selector, which we don't use.
// Injected from JS on purpose: PurgeCSS only scans php/html/jsx/tsx sources.
const css = `
.icf-easter-egg-message .newsticker-slide {
  border-radius: var(--bs-border-radius);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem var(--content-inset);
}

.icf-easter-egg-message .newsticker-slide > .text {
  text-align: center;
  padding-left: 3rem;
  padding-right: 3rem;
}

@media (min-width: 768px) {
  .icf-easter-egg-message .newsticker-slide {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }
}
`

// keep in sync with --icf-transition-base used by .slide-up
const transitionMs = 400

function injectStyles() {
  if (document.getElementById(styleId)) return
  const style = document.createElement('style')
  style.id = styleId
  style.textContent = css
  document.head.appendChild(style)
}

export function showMessage(options: {
  text: string
  durationMs?: number
  /** Font Awesome icon class - must be part of the subsetted kit */
  icon?: string
  /** theme color suffix for text-bg-*, as used by newsticker entries */
  color?: string
}) {
  const {
    text,
    durationMs = 5000,
    icon = 'fa-party-horn',
    color = 'black'
  } = options
  injectStyles()

  // only one hint at a time - a new one replaces the current one
  document.querySelector('.icf-easter-egg-message')?.remove()

  const wrapper = document.createElement('div')
  wrapper.className = 'newsticker icf-easter-egg-message'
  const toast = document.createElement('div')
  toast.className = 'newsticker-toast slide-up'
  toast.innerHTML = `
    <div class="container">
      <div class="position-relative">
        <div class="newsticker-slider overflow-hidden">
          <div class="newsticker-slide text-bg-${color}">
            <i class="icon icon--fixed-width ${icon}" aria-hidden="true"></i>
            <div class="text" role="status"></div>
            <div></div>
          </div>
        </div>
        <button type="button" class="btn close" aria-label="Close">
          <i class="icon icon--fixed-width fa-close" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  `
  const textElement = toast.querySelector('.text')
  if (textElement) textElement.textContent = text
  wrapper.appendChild(toast)

  // if a real newsticker is currently visible, stack the hint above it
  const realTicker = document.querySelector<HTMLElement>(
    '.wp-block-yellowtree-newsticker .newsticker-toast'
  )
  if (realTicker?.classList.contains('show')) {
    const height = realTicker.getBoundingClientRect().height
    if (height > 0) {
      toast.style.bottom = `calc(${Math.round(height)}px + 1rem)`
    }
  }

  let dismissed = false
  const dismiss = () => {
    if (dismissed) return
    dismissed = true
    toast.classList.remove('show')
    setTimeout(() => wrapper.remove(), transitionMs)
  }
  toast.querySelector('.close')?.addEventListener('click', dismiss)
  setTimeout(dismiss, durationMs)

  document.body.appendChild(wrapper)
  // double rAF: the element must be rendered once without .show so the
  // slide-up transition has a start state
  requestAnimationFrame(() => {
    requestAnimationFrame(() => toast.classList.add('show'))
  })
}
